import ReactDOM from 'react-dom';

import { ToastContainer } from 'react-toastify';
import AppStyle from 'modules/common/theme/appStyle';
import GlobalStyleV2 from 'modules/v2/common/theme/globalTheme';
import { Router } from 'modules/router';

import 'antd/dist/antd.css';
import 'react-toastify/dist/ReactToastify.css';

const toastContainer = ReactDOM.createPortal(
  <ToastContainer pauseOnHover={false} rtl={false} autoClose={3000} hideProgressBar closeOnClick />,
  document.getElementById('ToastContainer'),
);

const App = () => (
  <>
    <GlobalStyleV2 />
    <AppStyle />
    {toastContainer}
    <Router />
  </>
);

export default App;
